import React from 'react';

const AboutUs = () => {
  return (
    <div className="pt-20 min-h-screen bg-linen-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="font-display text-4xl font-semibold text-walnut-800 mb-8">About Us</h1>
        <div className="prose max-w-none">
          <p className="text-walnut-600 mb-6">
            Tree to Table is a local business started by 3 generations of artisans, 
            focused on creating unique and functional pieces from hand harvested wood. 
            From bowls, spoons, spatulas to signs and handmade goods of all types our artisans make a wide range of artwork. 
          </p>
          
          
          {/* John's Section */}
          <div className="flex flex-col md:flex-row items-center gap-8 mb-12">
            <img
              src="/images/john-bowls.jpg"
              alt="John holding a large turned bowl beside stacks of his bowls and utensils"
              className="w-full max-w-sm md:w-80 rounded-lg shadow-md object-cover"
            />
            <p className="text-walnut-600 flex-1">
              John has been woodworking for over thirty years. His specialty is turning logs
              into salad bowls, serving bowls, and other useful kitchen tools. He crafts
              utilitarian pieces for daily use as well as artistic pieces meant to highlight
              nature's beauty.
              <br /><br />
              He also loves to teach others how to turn their own bowls, offering personal
              hands-on tutoring in his shop for people who would like to make a unique
              handmade gift for someone special in their life. Most people who spend the day
              in his shop will make two bowls in that session and have a great time learning
              the craft of woodturning. His youngest student outside his family is 15, and his
              oldest student so far has been 82.
            </p>
          </div>

          {/* Edward's Section */}
          <div className="flex flex-col md:flex-row-reverse items-center gap-8 mb-12">
            <img
              src="/images/ed-shop.jpg"
              alt="Edward in a sawdust-covered apron and face shield with family in the Tree to Table woodshop"
              className="w-full max-w-sm md:w-80 rounded-lg shadow-md object-cover"
            />
            <p className="text-walnut-600 flex-1">
              Edward's passion for woodworking began in his youth, learning basics while working on housing customization like decks and furniture.
              Taught woodturning by John, his work reflects both functionality and artistic vision.
            </p>
          </div>

          {/* Cooper's Section */}
          <div className="flex flex-col md:flex-row items-center gap-8 mb-12">
            <img
              src="/images/cooper-bowl.jpg"
              alt="Cooper holding one of his turned wooden bowls"
              className="w-full max-w-sm md:w-80 rounded-lg shadow-md object-cover"
            />
            <p className="text-walnut-600 flex-1">
              Cooper specializes in small items, bowls and other kitchen tools. His attention to detail 
              and commitment to quality has made his pieces some of our most popular items. 
              Each piece he creates is carefully crafted to be both beautiful and practical for everyday use.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;